import { AbstractGetAllStore } from "../common/AbstractStores";
import Dispatcher from "../common/dispatcher";
import Actions from "./ReportsActions";
import { CustomerByLocalityReport } from "../generated";
import { InSessionStorage } from "../common/InLocalStorage";
import LoginActions from "../login/LoginActions";

class CustomersByLocalitiesStore extends AbstractGetAllStore<CustomerByLocalityReport>{
    constructor() {
        super(x => x.localityId || "", new InSessionStorage<CustomerByLocalityReport>("CustomerByLocalityReport"));
        Dispatcher
            .onfunction(Actions.getCustomersByLocalityReport, result => this.setAll(result))
            .onfunction(LoginActions.signOut, result => this.clear())
            ;
    }

    public useAll = () => this.useAllWithAction(() => Actions.getCustomersByLocalityReport());
}

export default new CustomersByLocalitiesStore()
